/*用export把方法暴露出来*/
/*设置cookie*/
export function setCookie(c_name,value,expire,path) {
    var date=new Date();
    date.setSeconds(date.getSeconds()+expire)
    // console.log(date.toGMTString())
    // console.log(escape(value))
    if(!path){
        path = "/";
    }
    document.cookie=c_name+ "="+value+"; expires="+date.toGMTString()+";path="+path;
    //console.log(document.cookie)
}
 
/*获取cookie*/
export function getCookie(c_name){
    if (document.cookie.length>0){
        let c_start=document.cookie.indexOf(c_name + "=")
        if (c_start!=-1){ 
            c_start=c_start + c_name.length+1 
            let c_end=document.cookie.indexOf(";",c_start)
            if (c_end==-1) c_end=document.cookie.length
                return unescape(document.cookie.substring(c_start,c_end))
            } 
        }
    return ""
}
 
/*删除cookie*/
export function delCookie(c_name){
    var value = getCookie(c_name)
    // console.log(value,c_name,'555')
    setCookie(c_name, "", -1)
    // var exp = new Date();
    // exp.setTime(exp.getTime() - 1);
    // var cval=getCookie(name);
    // if(cval!=null)
    //     document.cookie= name + "="+cval+";expires="+exp.toGMTString();
}


// WEBPACK FOOTER //
// ./src/assets/js/cookie.js